import { TBookingContext } from '@providers/booking/types'
import { getBaseGroup } from 'components-ui/src/offer_card/helper'
import { Types } from 'service-api'

export const sortOffers = (
  offers: Types.BookingSearchClientDto[] | Types.BookingSearchByDaysClientDto[],
  serviceTypeName: string,
  petGroup?: number
): Types.BookingSearchClientDto[] | Types.BookingSearchByDaysClientDto[] => {
  const sortedOffers = offers.sort((a, b) => {
    const firstAvailabilityGroups =
      (a as Types.BookingSearchClientDto).availabilityGroups ||
      (a as Types.BookingSearchByDaysClientDto).availabilityGroupsByDays ||
      []
    const secondAvailabilityGroups =
      (b as Types.BookingSearchClientDto).availabilityGroups ||
      (b as Types.BookingSearchByDaysClientDto).availabilityGroupsByDays ||
      []
    const firstAvailability = getBaseGroup(serviceTypeName, petGroup || 0, firstAvailabilityGroups).availabilities?.[0]
      .available
    const secondAvailability = getBaseGroup(serviceTypeName, petGroup || 0, secondAvailabilityGroups)
      .availabilities?.[0].available

    if (firstAvailability === secondAvailability) {
      return (a.offer?.order || 0) - (b.offer?.order || 0)
    } else {
      return firstAvailability ? -1 : 1
    }
  })

  return sortedOffers
}

export const hasOffersDiscount = (
  offers: Types.BookingSearchClientDto[] | Types.BookingSearchByDaysClientDto[],
  isOvernight: boolean = false
) =>
  !!offers.find((offer) =>
    isOvernight
      ? (offer as Types.BookingSearchClientDto).availabilityGroups?.find(
          (availabilityGroup) =>
            availabilityGroup?.availabilities?.find((availability) => availability.price?.discounts?.length)
        )
      : (offer as Types.BookingSearchByDaysClientDto).availabilityGroupsByDays?.find(
          (availabilityGroup) =>
            availabilityGroup?.[0].availabilities?.find((availability) => availability.price?.discounts?.length)
        )
  )

export const setUpTemperTest = (
  ctx: TBookingContext,
  dispatch: ({ type, payload }: { type: string; payload?: GenericSimpleBag }) => void,
  affectedByPetIds: string[]
): void => {
  dispatch({ type: 'SET_SERVICE_TYPE', payload: { value: ctx.data.temperTest } })
  // don't check affectedByIds for new customers because they don't have petIds yet so it can't match correctly -- just include them
  !ctx.isNewCustomer &&
    ctx.groups.map((group, groupIdx) => {
      group.pets.map((pet, petIdx) => {
        if (!affectedByPetIds.includes(pet.id)) {
          dispatch({
            type: 'SET_PET_IN_ROOM',
            payload: { groupIdx: groupIdx, petIdx: petIdx, value: 0 },
          })
        } else {
          // we want all temper test pets in the same room so the search request is correct
          dispatch({
            type: 'SET_PET_IN_ROOM',
            payload: { groupIdx: groupIdx, petIdx: petIdx, value: 1 },
          })
        }
      })
    })
  dispatch({ type: 'REGROUP_PETS' })
}

export const listPetNames = (ctx: TBookingContext, petGroup: number): string[] | undefined => {
  const groups = ctx.cart.groups[0]?.pets?.[0]?.name ? ctx.cart.groups : ctx.confirmation.groups
  return groups?.[petGroup]?.pets.map(({ name }) => name)
}
